module.exports = __webpack_public_path__ + "img/news9-4.45f0a0dd.png";